import React from "react";
import "./Support.css";

const SupportPage = () => (
  <>
    <div className="dashboard_right">
      <div className="supportsection">
        <h4 className="mb-1">Help/Support</h4>
        <div className="supportinquery">
          <form className="profile_form">
            <div className="row">
              <div className="col-sm-6">
                <div className="emailinput">
                  <label>Subject</label>
                  <div className="d-flex">
                    <input type="text" placeholder="Enter subject" maxLength={200} defaultValue="" />
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="emailinput">
                  <label>Category</label>
                  <div className="d-flex">
                    <select defaultValue="" className="form-select">
                      <option value="" hidden>Select Category</option>
                      <option value="billing">Billing</option>
                      <option value="technical_issue">Technical Issue</option>
                      <option value="account">Account</option>
                      <option value="trading">Trading</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="emailinput">
                  <label>Priority</label>
                  <div className="d-flex">
                    <select defaultValue="medium" className="form-select">
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="emailinput">
                  <label>Supporting documents (Optional)</label>
                  <div className="d-flex">
                    <input type="file" placeholder="" accept=".png,.jpg,.jpeg" />
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="emailinput">
                  <label>Description</label>
                  <div className="d-flex">
                    <textarea placeholder="Describe your issue in detail" maxLength={2000} defaultValue=""></textarea>
                  </div>
                </div>
              </div>

              <div className="col-sm-12">
                <button type="button" className="submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
        <div className="tt_main issuelist_data">
          <div className="coin_view_top">
            <h4>Issue List</h4>

            <div className="searchBar custom-tabs">
              <i className="ri-search-2-line"></i>
              <input type="search" className="custom_search" placeholder="Search ticket id" defaultValue="" />
            </div>
          </div>

          <div className="inngerbox cng-pass overflow_unset ">
            <div className="desktop_view">
              <div className="table-responsive">
                <table className="table table_home ">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Ticket ID</th>
                      <th>Category</th>
                      <th>Subject</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className=" font-weight-bold issue_text">
                      <td>1</td>
                      <td>
                        TKT-2026-001
                        <button type="button" className="btn btn-link p-0">
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </td>
                      <td className="text-capitalize">technical issue</td>
                      <td>Withdrawal not credited</td>
                      <td className="badge bg-secondary  text-capitalize">medium</td>
                      <td>
                        Open{" "}
                        <small>
                          <i className="ri-circle-fill" style={{ color: "green" }}></i>
                        </small>
                      </td>
                      <td>
                        <button type="button" className="btn btn-xs btn-success" data-bs-toggle="modal" data-bs-target="#security_verification">
                          <span>View</span>
                        </button>
                      </td>
                    </tr>
                    <tr className="issue_text">
                      <td>2</td>
                      <td>
                        TKT-2026-002
                        <button type="button" className="btn btn-link p-0">
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </td>
                      <td className="text-capitalize">account</td>
                      <td>Cannot enable 2FA</td>
                      <td className="badge bg-secondary  text-capitalize">low</td>
                      <td>Closed</td>
                      <td>
                        <button type="button" className="btn btn-xs btn-success" data-bs-toggle="modal" data-bs-target="#security_verification">
                          <span>View</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mobile_view mt-2">
              <div className="table-responsive">
                <table className=" ">
                  <thead>
                    <tr>
                      <th>Ticket ID</th>
                      <th>Category</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th className="right_t">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="td_first">TKT-2026-001</div>
                      </td>
                      <td className="text-capitalize">
                        <small>technical issue</small>
                      </td>
                      <td>
                        <span className="badge  bg-secondary  text-capitalize" style={{ fontSize: "10px" }}>medium</span>
                      </td>
                      <td>
                        Open{" "}
                        <small>
                          <i className="ri-circle-fill" style={{ color: "green" }}></i>
                        </small>
                      </td>
                      <td className="right_t">
                        <button type="button" className="btn btn-xs btn-success" data-bs-toggle="modal" data-bs-target="#security_verification">
                          <small>View</small>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="td_first">TKT-2026-002</div>
                      </td>
                      <td className="text-capitalize">
                        <small>account</small>
                      </td>
                      <td>
                        <span className="badge  bg-secondary  text-capitalize" style={{ fontSize: "10px" }}>low</span>
                      </td>
                      <td>Closed</td>
                      <td className="right_t">
                        <button type="button" className="btn btn-xs btn-success" data-bs-toggle="modal" data-bs-target="#security_verification">
                          <small>View</small>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      className="modal fade search_form chatmessages"
      id="security_verification"
      tabIndex="-1"
      aria-labelledby="securityVerificationLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          <div className="chat-container">
            <div className="chat-header">
              <h3>Help/Support</h3>
              <div className="ticket">
                <div className="ticket cursor-pointer">
                  <i className="ri-file-copy-line"></i>
                  TKT-2026-001
                </div>
              </div>
            </div>

            <div className="chat-body">
              <div
                className="ticket-details mb-4"
                style={{ padding: "12px 16px", borderBottom: "1px solid #444", backgroundColor: "rgb(47 53 66)" }}
              >
                <div style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "12px", color: "#888", marginRight: "8px" }}>Ticket Created On:</span>
                  <span style={{ fontSize: "14px", color: "#fff" }}>09/04/2026 10:00 AM</span>
                </div>
                <div style={{ marginBottom: "8px" }}>
                  <span style={{ fontSize: "12px", color: "#888", marginRight: "8px" }}>Subject:</span>
                  <span style={{ fontSize: "14px", color: "#fff" }}>Withdrawal not credited</span>
                </div>
                <div style={{ marginBottom: "8px", display: "flex", gap: "16px" }}>
                  <div>
                    <span style={{ fontSize: "12px", color: "#888", marginRight: "8px" }}>Category:</span>
                    <span className="badge bg-secondary text-capitalize" style={{ fontSize: "12px" }}>
                      technical issue
                    </span>
                  </div>
                  <div>
                    <span style={{ fontSize: "12px", color: "#888", marginRight: "8px" }}>Priority:</span>
                    <span className="badge bg-secondary text-capitalize" style={{ fontSize: "12px" }}>
                      medium
                    </span>
                  </div>
                </div>
                <div>
                  <span style={{ fontSize: "12px", color: "#888", marginRight: "8px" }}>Description:</span>
                  <span style={{ fontSize: "13px", color: "#ccc" }}>
                    I initiated a USDT withdrawal 24 hours ago. Tx shows completed but balance not received.
                  </span>
                </div>
              </div>

              <div>
                <div className="message left">
                  <div className="avatar">T</div>
                  <div className="bubble">
                    Thank you for reaching out. We are reviewing your withdrawal and will update you shortly.
                  </div>
                </div>
              </div>
              <div>
                <div className="message right">
                  <div className="bubble">Please share the transaction hash when you have it.</div>
                  <div className="avatar">D</div>
                </div>
              </div>
              <div>
                <div className="message left">
                  <div className="avatar">T</div>
                  <div className="bubble">We have located your transfer. It should appear in your wallet within the hour.</div>
                </div>
              </div>
            </div>
            <div className="chat-footer">
              <input type="text" placeholder="Write your message here..." maxLength={1000} defaultValue="" />
              <div className="icon-btn send-btn cursor-pointer">➤</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default SupportPage;
